import { useTenantContext } from "../../../context/Tenant/TenantContext";
import { useAuthContext } from "../../auth/AuthContext";
import ViewLayerSelect from "./menuButtons/ViewLayerSelect";
import NotificationButton from "./menuButtons/NotificationButton";
import BasketButton from "./menuButtons/BasketButton";
import CurrencySelect from "./menuButtons/CurrencySelect";
import UserDropdown from "./menuButtons/UserDropdown";
import SwitchStack from "../switches/SwitchStack";
import styled from "styled-components";
import { Nav } from "react-bootstrap";
import UpgradeLicence from "./menuButtons/UpgradeLicence";
import { jwtDecode } from "jwt-decode";
import { useMemo } from "react";

const StyledNav = styled(Nav)`
  gap: 0.5rem;
`;

const LoggedInMenu = () => {
  const { user } = useAuthContext();

  const licenceName = useMemo(() => {
    if (!user?.token) return undefined;
    const payload = jwtDecode(user.token) as any;
    return payload.LicenceName;
  }, [user]);

  const { config } = useTenantContext();

  const hideFeatures = config?.hideFeatures ?? [];
  const hideLayers = config?.hideLayers ?? [];

  const notificationsEnabled = !hideFeatures.includes("notifications");
  const upgradeLicenceEnabled = !hideFeatures.includes("upgradeLicense");
  const adminEnabled = !hideFeatures.includes("admin");
  const myLicenceEnabled = !hideFeatures.includes("myLicence");

  const ptLayerEnabled = !hideLayers.includes("Basemap:PublicTransport");

  return (
    <StyledNav className="align-items-center">
      {upgradeLicenceEnabled && licenceName === "Bronze" && <UpgradeLicence />}
      <ViewLayerSelect />
      {notificationsEnabled && (
        <NotificationButton notificationsEnabled={notificationsEnabled} />
      )}
      <BasketButton />
      <CurrencySelect />
      <UserDropdown
        adminEnabled={adminEnabled}
        myLicenceEnabled={myLicenceEnabled}
      />
      <SwitchStack ptLayerEnabled={ptLayerEnabled} />
    </StyledNav>
  );
};

export default LoggedInMenu;
